// This file is automatically generated. Do not edit manually.

import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SafetyControlSurveyActionApi {
	export async function startSurvey(args: { safetyControlSurveyId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/surveys/startSurvey",
			method: "POST",
			data: {
				safetyControlSurveyId: args.safetyControlSurveyId,
			},
		});
		return response as void;
	}

	export async function closeSurvey(args: { safetyControlSurveyId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/surveys/closeSurvey",
			method: "POST",
			data: {
				safetyControlSurveyId: args.safetyControlSurveyId,
			},
		});
		return response as void;
	}
}
